import { QUERYSTATUS_TASK, QUERYSTATUS_TASK_SUCCESSFUL, QUERYSTATUS_TASK_FAILED } from './actionTypes';

const initialState = {
    queryTaskStatusStartError: null, messageQueryStatusTask: null, loadingQueryStatusTask: false
}

const queryTaskStatusStart = (state = initialState, action) => {
    if (action.type === QUERYSTATUS_TASK_SUCCESSFUL) {
    }
    switch (action.type) {
        case QUERYSTATUS_TASK:
            state = {
                ...state,
                loadingQueryStatusTask: true,
                queryTaskStatusStartError: null,
                messageQueryStatusTask: null,
            }
            break;
        case QUERYSTATUS_TASK_SUCCESSFUL:
            state = {
                ...state,
                loadingQueryStatusTask: false,
                messageQueryStatusTask: action.payload,
                queryTaskStatusStartError: null
            }
            break;
        case QUERYSTATUS_TASK_FAILED:
            state = {
                ...state,
                messageQueryStatusTask: null,
                loadingQueryStatusTask: false,
                queryTaskStatusStartError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default queryTaskStatusStart;